export default "__VITE_PUBLIC_ASSET__17a32d2b__"